import { render, staticRenderFns } from "./RelatorioNFRecebidaView.vue?vue&type=template&id=0f27b7ca&scoped=true"
import script from "./RelatorioNFRecebidaView.vue?vue&type=script&lang=js"
export * from "./RelatorioNFRecebidaView.vue?vue&type=script&lang=js"
import style0 from "./RelatorioNFRecebidaView.vue?vue&type=style&index=0&id=0f27b7ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f27b7ca",
  null
  
)

export default component.exports